const cockpit = [{
  path: '/cockpit',
  name: 'cockpit',
  component: () => import('@/views/cockpit')
}, {
  path: '/cockpit/effect',
  name: 'cockpit-effect',
  component: () => import('@/views/cockpit/efficiency')
}, {
  path: '/cockpit/business',
  name: 'cockpit-business',
  component: () => import('@/views/cockpit/business')
}, {
  path: '/cockpit/jysj',
  name: 'cockpit-jysj',
  component: () => import('@/views/cockpit/yunding')
}]

export default cockpit



// WEBPACK FOOTER //
// ./src/router/cockpit.js